import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/web.dom-collections.for-each.js";
/**
 * Detect IE browser
 * @const {boolean}
 * @private
 */
var isIE = typeof document !== 'undefined' && document.documentMode;
var supportNativeLazy = 'loading' in HTMLImageElement.prototype;
var defaultConfig = {
  rootMargin: '100px',
  threshold: 0,
  load: function load(element) {
    if (element.nodeName.toLowerCase() === 'picture' && element.querySelectorAll('img').length === 0) {
      var img = document.createElement('img');
      if (isIE && element.getAttribute('data-iesrc')) {
        img.src = element.getAttribute('data-iesrc');
      }
      if (element.getAttribute('data-alt') !== null) {
        img.alt = element.getAttribute('data-alt');
      }
      if (element.getAttribute('data-class')) {
        img.classList.add(element.getAttribute('data-class'));
      }
      if (!isIE && element.getAttribute('data-default')) {
        img.src = element.getAttribute('data-default');
      }
      element.appendChild(img);
    }
    if (element.getAttribute('data-src')) element.src = element.getAttribute('data-src');
    if (element.getAttribute('data-srcset')) element.setAttribute('srcset', element.getAttribute('data-srcset'));
    if (element.getAttribute('data-background-image')) element.style.backgroundImage = "url('".concat(element.getAttribute('data-background-image'), "')");
    if (element.getAttribute('data-src-content')) {
      var loadContentEvent = new CustomEvent('contentLoading');
      document.dispatchEvent(loadContentEvent);
    }
  },
  // eslint-disable-next-line
  loaded: function loaded() {}
};

/**
 * Add lazy-loaded class when element was loaded
 * @param {*} element
 */
function markAsLoaded(element) {
  if (element.nodeName === 'svg' && !!window.MSInputMethodContext && !!document.documentMode) {
    var appliedClasses = element.getAttribute('class') || '';
    appliedClasses = appliedClasses.split(' ').indexOf('lazy-loaded') > -1 ? "".concat(element.className, " lazy-loaded") : appliedClasses.replace('lazy', '');
    element.setAttribute('class', appliedClasses);
  } else {
    element.classList.add('lazy-loaded');
    element.classList.remove('lazy');
  }
}
var isLoaded = function isLoaded(element) {
  return element.getAttribute('data-loaded') === 'true';
};
var onIntersection = function onIntersection(load, loaded) {
  return function (entries, observer) {
    entries.forEach(function (entry) {
      if (entry.intersectionRatio > 0 || entry.isIntersecting) {
        observer.unobserve(entry.target);
        if (!isLoaded(entry.target)) {
          load(entry.target);
          markAsLoaded(entry.target);
          loaded(entry.target);
        }
      }
    });
  };
};
var getElements = function getElements(selector) {
  var root = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document;
  if (selector instanceof Element) {
    return [selector];
  }
  if (selector instanceof NodeList) {
    return selector;
  }
  return root.querySelectorAll(selector);
};
function lazyLoad(selector) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _Object$assign = Object.assign({}, defaultConfig, options),
    root = _Object$assign.root,
    rootMargin = _Object$assign.rootMargin,
    threshold = _Object$assign.threshold,
    load = _Object$assign.load,
    loaded = _Object$assign.loaded;
  var observer = new IntersectionObserver(onIntersection(load, loaded), {
    root: root,
    rootMargin: rootMargin,
    threshold: threshold
  });
  return {
    observe: function observe() {
      var elements = getElements(selector, root);
      for (var i = 0; i < elements.length; i++) {
        if (supportNativeLazy) {
          // Swap image now, and let the browser handle the lazy loading natively
          // load(elements[i]);
          // markAsLoaded(element);
          // loaded(element);
        }
        if (isLoaded(elements[i])) {
          continue;
        }
        if (observer) {
          observer.observe(elements[i]);
          continue;
        }
        load(elements[i]);
        markAsLoaded(elements[i]);
        loaded(elements[i]);
      }
    },
    triggerLoad: function triggerLoad(element) {
      if (isLoaded(element)) {
        return;
      }
      load(element);
      markAsLoaded(element);
      loaded(element);
    },
    observer: observer
  };
}
export var init = lazyLoad;